export default __webpack_public_path__ + "static/media/paypal.bc8a21a9.svg";